import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { FaAngleLeft } from 'react-icons/fa6';
import chooseCardIcon from '../../../../assets/img/icon/card_icon3.png';
import cardBgImg from '../../../../assets/img/logo/card_bg-cardplot.png';
import cardBgImg1 from '../../../../assets/img/logo/card_bg_logo.png';
import visaCardLogo from '../../../../assets/img/logo/visa-card-logo.png';
import masterCardLogo from '../../../../assets/img/logo/mastercard-logo.png';
import verveCardLogo from '../../../../assets/img/logo/verve-card-logo.png';
import masterCardBgImg from '../../../../assets/img/logo/masterCard-watermark.png';
import brandLogo from '../../../../assets/img/logo/favicon.png';
import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps';

// Define available card color themes
const colorOptions = [
  { color: '#F5F5F5', bgImage: cardBgImg1 }, 
  { color: '#2A0A7D', bgImage: cardBgImg }, 
  { color: '#0A95FF', bgImage: masterCardBgImg },
];

const CreateCard2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const selectedCardData = location.state?.selectedCardData;
  const accountPurpose = location.state?.accountPurpose;
  const expectedMonthlyVolume = location.state?.expectedMonthlyVolume;

  const [selectedOption, setSelectedOption] = useState(location.state?.cardTheme || colorOptions[0]);
  const [nickname, setNickname] = useState(location.state?.nickname || '');

  const cardLogos = {
    "verve": verveCardLogo,
    "mastercard": masterCardLogo,
    "visa": visaCardLogo
  };

  useEffect(() => {
    if (!selectedCardData) {
      navigate("/user/cards/step1", { replace: true });
    }
  }, [selectedCardData]);

  // Keep state updated if location.state changes
  useEffect(() => {
    if (location.state?.cardTheme) {
      setSelectedOption(location.state.cardTheme);
    }
    if (location.state?.nickname) {
      setNickname(location.state.nickname);
    }
  }, [location.state]);

  const handleGoBack = () => {
    navigate("/user/cards/step1", { state: { selectedCardData, accountPurpose, expectedMonthlyVolume } });
  };

  const handleContinue = () => {
    if (nickname) {
      const customizedCardDetails = {
        nickname: nickname,
        cardName: selectedCardData?.name,
        cardSlug: selectedCardData?.slug,
        cardCurrency: selectedCardData?.currency,
        cardType: selectedCardData?.type,
        cardTypeLogo: selectedCardData?.slug ? cardLogos[selectedCardData.slug] : null,
        fee_configurations: selectedCardData?.fee_configurations || [],
        supported_countries: selectedCardData?.supported_countries || [],
        cardTheme: {
          color: selectedOption?.color,
          bgImage: selectedOption?.bgImage
        },
        accountPurpose: accountPurpose,
        expectedMonthlyVolume: expectedMonthlyVolume,
      };
  
      // Pass state containing both customizedCardDetails and selectedCardData to fund_card step
      navigate("/user/cards/fund_card", { state: { customizedCardDetails, selectedCardData } });
    }
  };

  return (
    <section className='create__card__page create__card__page2 pt-4'>
      <div className="d-flex align-items-center mb-4 px-md-3">
        <button 
          onClick={handleGoBack} 
          className="btn btn-light d-flex align-items-center shadow-sm" 
          style={{ 
            borderRadius: '20px', 
            padding: '6px 16px',
            backgroundColor: '#ffffff',
            border: '1px solid #E0E4EC',
            color: '#19064B',
            fontWeight: '500',
            fontSize: '13px',
            gap: '6px'
          }}
        >
          <FaAngleLeft size={13} />
          <span>Go back</span>
        </button>
      </div>

      {/* Progress Steps */}
      <section><CardsProgressSteps currentStep={2} /></section>

      {/* Card Customization Section */}
      <section className="create-card_section customize__card">
        <div className="container"> 
          {/* Card Display */}
          <div className="choose-theme d-flex flex-column align-items-center">
            <div className="mt-4 cards-showcase w-100 d-flex flex-column align-items-center">
              <div 
                className="card-display mx-auto mb-4 position-relative" 
                style={{
                  backgroundColor: selectedOption.color,
                  backgroundImage: `url(${selectedOption.bgImage})`,
                  boxShadow: `0 20px 40px -10px ${selectedOption.color === '#F5F5F5' ? 'rgba(0,0,0,0.1)' : selectedOption.color}`,
                  transition: 'all 0.3s ease',
                  borderRadius: '16px'
                }}
              >
                <div className="card-branding">
                  <div className="card-text-display">
                    <div className={`card-logo d-flex align-items-center gap-1 text-white ${selectedOption.color === '#F5F5F5' && 'dark-logo'}`}>
                      <img src={brandLogo} alt="logo" width='16.71px' height='16.71px' />
                      <span>Cardplot</span>
                    </div>
                    <div className={`card-type ${selectedOption.color === colorOptions[0].color && 'dark-logo'}`}>
                      <span className='text-right'>debit</span>
                      {selectedCardData && (
                        <img src={cardLogos[selectedCardData.slug]} alt="Card Type" className='img-fluid' />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Color Selection Options */}
              <div className="theme-selector d-flex flex-row gap-4 justify-content-center mt-3 mb-4 w-100">
                {colorOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`rounded-circle border-0 ${selectedOption.color === option.color ? "shadow" : ""}`}
                    style={{ 
                      width: '40px', 
                      height: '40px',
                      backgroundColor: option.color, 
                      backgroundImage: `url(${option.bgImage})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      boxShadow: selectedOption.color === option.color ? `0 0 0 3px #fff, 0 0 0 5px ${option.color}` : 'none',
                      transition: 'all 0.2s ease',
                      border: selectedOption.color === option.color ? 'none' : '1px solid #E0E4EC'
                    }}
                    onClick={() => setSelectedOption(option)}
                  />
                ))}
              </div>
            </div>

            {/* Nickname Input Field */}
            <div className="form__card-section my-4 w-100 text-start" style={{ maxWidth: '400px' }}>
              <label className="form-label fw-medium mb-2" style={{ color: '#19064B', fontSize: '14px' }}>
                Card Nickname <span className="text-danger">*</span>
              </label>
              <input 
                type="text" 
                className="form-control form-control-lg shadow-sm" 
                placeholder="e.g. My Shopping Card"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                style={{ fontSize: '15px', borderRadius: '12px', border: '1px solid #E0E4EC', color: '#19064B', padding: '12px 16px' }}
              />
            </div>

            {/* Continue Button */}
            <div className="d-flex align-items-center justify-content-center mt-3 w-100" style={{ maxWidth: '400px' }}>
              <button onClick={handleContinue} className="btn primary__btn w-100 py-3 fw-medium shadow-sm" disabled={!nickname} style={{ fontSize: '15px', borderRadius: '12px' }}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default CreateCard2;